import {
  FetchActionByContextFailureAction,
  FetchActionByContextRequestAction,
  FetchActionByContextSuccessAction,
  FetchLinkedActionsFailureAction,
  FetchLinkedActionsRequestAction,
  FetchLinkedActionsSuccessAction,
  PlanActionsContext,
  ReportActionTypes,
  ReportFilters,
  StrapiActionTypes,
} from '../../types/types';

//! действия к ответам
export const fetchLinkedActionsRequest = (filters: ReportFilters): FetchLinkedActionsRequestAction => ({
  type: ReportActionTypes.FETCH_LINKED_ACTIONS_REQUEST,
  payload: { filters },
});

export const fetchLinkedActionsSuccess = (data: any[]): FetchLinkedActionsSuccessAction => ({
  type: ReportActionTypes.FETCH_LINKED_ACTIONS_SUCCESS,
  payload: { data },
});

export const fetchLinkedActionsFailure = (error: string): FetchLinkedActionsFailureAction => ({
  type: ReportActionTypes.FETCH_LINKED_ACTIONS_FAILURE,
  payload: { error },
});

export const fetchLinkedActions = (filters?: ReportFilters) => fetchLinkedActionsRequest(filters || {});

export const fetchActionByContextRequest = (modelName: string, context: PlanActionsContext): FetchActionByContextRequestAction => ({
  type: StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_REQUEST,
  payload: { modelName, context },
});

export const fetchActionByContextSuccess = (data: any[]): FetchActionByContextSuccessAction => ({
  type: StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_SUCCESS,
  payload: { data },
});

export const fetchActionByContextFailure = (error: string): FetchActionByContextFailureAction => ({
  type: StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_FAILURE,
  payload: { error },
});
